import { CardTitle } from "@/components/ui/card";
// import { Switch } from "@/components/ui/switch";
import type { PulseHeaderProps } from "../../types/pulse.types";

export default function PulseHeader({ title, lastUpdated }: PulseHeaderProps) {
  return (
    <div className="flex w-full flex-col gap-0">
      <CardTitle className="flex items-center gap-2.5 text-[28px] leading-[36px] -tracking-wide text-neutral-950">
        {/* <div className="flex h-fit items-center gap-2.5">
          <Switch checked={status === "pending"} onCheckedChange={() => {}} />
        </div> */}
        {title}
      </CardTitle>
      <p className="text-sm text-neutral-600">
        Last Updated:{" "}
        {lastUpdated ? new Date(lastUpdated).toLocaleString() : "N/A"}
      </p>
    </div>
  );
}
